export const FolderListApiDto = Symbol.for('FolderListApiDto');
